import { beginTask, endTask } from 'redux-nprogress';
import { loadWeeks, selectCurrent, selectWeeks } from '../../../../store/reducers/season';
import { selectQuery } from '../../../../store/reducers/location.selectors';
import { selectFormulasState } from '../../../../store/reducers/formula';
import routes from '../../../routes.global';
import viewNames from '../../../../store/actions/view.types';
import { loadToolDescriptions } from '../../../../store/reducers/toolDescriptions';

// ------------------------------------
// Selectors
// ------------------------------------
export const STORE_KEY = 'auction12';
export const selectAuction12State = state => state[STORE_KEY];
export const selectAuction12 = state => selectAuction12State(state).currentAuction12;

// ------------------------------------
// Reducer
// ------------------------------------
const actions = {};
const initialState = {
  currentAuction12: {},
  year: null,
  week: null,
  formulaId: 1,
  hasLoaded: false,
  error: null,
};

export const reducer = (state = initialState, action) => {
  const handler = actions[action.type];

  return handler ? handler(state, action) : state;
};

export default reducer;

// ------------------------------------
// Load Cheat Sheet from api
// ------------------------------------
export const LOAD_AUCTION12_REQUEST = `${STORE_KEY}/LOAD_AUCTION12_REQUEST`;
export const LOAD_AUCTION12_SUCCESS = `${STORE_KEY}/LOAD_AUCTION12_SUCCESS`;
export const LOAD_AUCTION12_ERROR = `${STORE_KEY}/LOAD_AUCTION12_ERROR`;

export const loadAuction12Request = payload => ({
  type: LOAD_AUCTION12_REQUEST,
  payload: { ...payload },
});
export const loadAuction12Success = ({ cheatsheet }, year, week, formulaId) => ({
  type: LOAD_AUCTION12_SUCCESS,
  payload: { cheatsheet, year, week, formulaId },
});
export const loadAuction12Error = error => ({
  type: LOAD_AUCTION12_ERROR,
  payload: { error },
});

actions[LOAD_AUCTION12_REQUEST] = (state, { payload }) => ({ ...state,
  year: payload.year,
  week: payload.week,
  formulaId: payload.formulaId,
});
actions[LOAD_AUCTION12_SUCCESS] = (state, { payload }) => ({ ...state,
  hasLoaded: true,
  currentAuction12: payload.cheatsheet,
  year: payload.year,
  week: payload.week,
  formulaId: payload.formulaId,
});
actions[LOAD_AUCTION12_ERROR] = (state, { payload }) => ({ ...state,
  hasLoaded: false,
  error: payload.error,
});

export const loadAuction12 = (year, week, formulaId) => async (dispatch, getState, { api }) => {
  try {
    dispatch(beginTask());
    dispatch(loadAuction12Request(year, week, formulaId));
    const auction12 = await api.cheatSheets.getByWeekAuction12(year);

    return dispatch(loadAuction12Success(auction12, year, week, formulaId));
  } catch (error) {
    console.error(error);
    return dispatch(loadAuction12Error(error));
  } finally {
    dispatch(endTask());
  }
};

// ------------------------------------
// View
// ------------------------------------
export const AUCTION12_VIEW = `${STORE_KEY}/AUCTION12_VIEW`;

viewNames[AUCTION12_VIEW] = 'Auction12';
routes[AUCTION12_VIEW] = {
  path: '/fantasy-football-rankings-cheat-sheets/:year/auction-12-team',
  thunk: async (dispatch, getState) => {
    const state = getState();

    let { week, formulaId } = selectQuery(state);
    let { year } = state.location.payload;

    const { season: currentYear, week: currentWeek } = selectCurrent(state, 'projections');

    if (!formulaId) formulaId = selectFormulasState(state).defaultFormula;

    await dispatch(loadWeeks(year));

    if (typeof week !== 'number') {
      if (year === currentYear) {
        week = currentWeek;
      } else {
        week = selectWeeks(getState(), year, 'projections')[0];
      }
    }

    // Needs to await otherwise data won't load on SSR
    await dispatch(loadAuction12(year, week, formulaId));
    await dispatch(loadToolDescriptions());
  },
};



// WEBPACK FOOTER //
// ./src/app/views/Auction12/module/auction12.js